<!-- You can replicate your original look & feel here. -->

<!-- Example: A Banner Subtype Grid -->
@if(selectedBanner){
    <div class="grid grid-cols-3 gap-4 text-normal my-4 text-center">
        @for (banner of selectedBanner; track $index){
            <a
                    (click)="onSelect(banner.type, banner.type)"
                    class="cursor-pointer text-gray-400 p-4 bg-card
             hover:bg-card-hover rounded-xl transition-all"
            >
                <div
                        class="bg-[url('/assets/image/' + banner.image)]
               bg-cover w-full h-32 mb-4"
                >
                </div>
                {{ banner.label }}
            </a>
        }
    </div>
}
@if(!selectedBanner){
    <div class="grid mt-5 bg-card w-full grid-cols-5 text-gray-400">
        @for (type of generalSectionTypes; track $index){
            <a
                    (click)="onSelect(type.type)"
                    class="p-4 text-center cursor-pointer hover:bg-bg_primary
                 transition-all rounded-md"
            >
                {{type.type}}
                <!-- You can use inline SVG or text icons here. -->
                <svg *ngIf="type.icon === '...'" class="m-auto" ...>...</svg>
                <div>{{ type.label }}</div>
            </a>
        }
    </div>
}
